"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CropParameterWriter = void 0;
var free_cropParameter_1 = require("../cropParameter/free.cropParameter");
function writeFreeCropParameter(cropParameter) {
    var state = cropParameter.state;
    var x = state.x;
    var y = state.y;
    var width = state.width;
    var height = state.height;
    return {
        id: state.id,
        tag: 'free',
        x: x,
        y: y,
        width: width,
        height: height
    };
}
var CropParameterWriter = /** @class */ (function () {
    function CropParameterWriter() {
    }
    CropParameterWriter.write = function (cropParameter) {
        if (free_cropParameter_1.CollectionModelFreeCropParameter.isFree(cropParameter)) {
            return writeFreeCropParameter(cropParameter);
        }
        throw new Error("Unexpected drawable: ".concat(cropParameter.id, ":").concat(cropParameter.state.tag));
    };
    return CropParameterWriter;
}());
exports.CropParameterWriter = CropParameterWriter;
//# sourceMappingURL=collection.model.write.cropParameter.js.map